import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { getLookUpTables } from '../actions/datamodel.actions';
import { ApiConstants } from 'src/app/base/api-constants';
import {
  deleteViewerInfo,
  dragDropFailure,
  dragDropSuccess,
  parTblFailure,
  parTblSuccess,
  tableTypeFailure,
  tableTypeSuccess,
  updParentTbl,
  updTableType,
  updateAppDM,
  updateAppDMFailure,
  updateAppDMSuccess,
  updateDragDrop,
  updateViewerInfo
} from '../actions/applicationdatamodel.actions';
import { ApplicationTypes } from 'src/app/services/util.enum';
import { AppGlobalService } from 'src/app/services/app.global.service';

@Injectable()
export class AppDataModelEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private appGlobalService = inject(AppGlobalService);

  updateAppDM$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateAppDM),
        map((action) => {
          if (!action.appDMData) {
            return;
          }
          this.store.dispatch(updateAppDMSuccess({ appDMSuccData: null }));
          this.store.dispatch(updateAppDMFailure({ appDMFailData: null }));
          this.baseService[action.apiConstants?.method](action.apiConstants, action.appDMData).subscribe(
            (results: any) => {
              if (
                this.appGlobalService.get('applicationType') !== ApplicationTypes.INDEPENDENT &&
                results &&
                results.length !== 0 &&
                (results[0]?.t_lookupFields || results[0]?.name)
              ) {
                this.store.dispatch(getLookUpTables({ apiConstants: ApiConstants.getLookUpTables }));
              }
              this.store.dispatch(updateAppDMSuccess({ appDMSuccData: results }));
            },
            (err: any) => {
              const data = Array.isArray(action.appDMData) ? action.appDMData[0] : action.appDMData;
              this.store.dispatch(updateAppDMFailure({ appDMFailData: { err: err, actionData: data } }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  updateViewerInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateViewerInfo),
        map((action) => {
          if (!action.userData) {
            return;
          }
          this.baseService[action.vwApiConstants?.method](action.vwApiConstants, action.userData).subscribe();
        })
      ),
    { dispatch: false }
  );

  deleteViewerInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteViewerInfo),
        map((action) => {
          if (!action.userData) {
            return;
          }
          this.baseService[action.delApiConstants?.method](action.delApiConstants, action.userData).subscribe();
        })
      ),
    { dispatch: false }
  );

  updateDragDrop$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateDragDrop),
        map((action) => {
          if (!action.data) {
            return;
          }
          this.store.dispatch(dragDropFailure({ dropFailed: null }));
          this.store.dispatch(dragDropSuccess({ dropSucc: null }));
          this.baseService[action.dropApiConstants?.method](action.dropApiConstants, action.data).subscribe(
            (results: any) => {
              this.store.dispatch(dragDropSuccess({ dropSucc: results }));
            },
            (err: any) => {
              this.store.dispatch(dragDropFailure({ dropFailed: { err: err, actionData: action.data } }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  updParentTbl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updParentTbl),
        map((action) => {
          if (!action.parTblData) {
            return;
          }
          this.store.dispatch(parTblFailure({ parTblFailed: null }));
          this.store.dispatch(parTblSuccess({ parTblSucc: null }));
          this.baseService[action.parApiConstants?.method](action.parApiConstants, action.parTblData).subscribe(
            (results: any) => {
              this.store.dispatch(parTblSuccess({ parTblSucc: results }));
            },
            (err: any) => {
              this.store.dispatch(parTblFailure({ parTblFailed: { err: err, actionData: action.parTblData } }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  updTableType$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updTableType),
        map((action) => {
          if (!action.payload) {
            return;
          }
          this.store.dispatch(tableTypeFailure({ tblTypeFailed: null }));
          this.store.dispatch(tableTypeSuccess({ tblTypeSucc: null }));
          this.baseService[action.tblTypeApiConstants?.method](action.tblTypeApiConstants, action.payload).subscribe(
            (results: any) => {
              this.store.dispatch(tableTypeSuccess({ tblTypeSucc: results }));
            },
            (err: any) => {
              this.store.dispatch(
                tableTypeFailure({ tblTypeFailed: { err: err, actionData: action.payload?.tableProperties } })
              );
            }
          );
        })
      ),
    { dispatch: false }
  );
}
